// extracted by mini-css-extract-plugin
module.exports = {"customCardBody":"PageLayout_customCardBody__2QdFu"};